<template>
  <div id="user-kit">
    <h1 class="page-title">{{ $t('UserKit.user_kit') }}</h1>

    <div>
      <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx">
        <li class="nav-item col-4" v-for="tab in listTab">
          <a
            href="#"
            data-toggle="tab"
            :class="{ active: isActiveTab(tab.name) }"
            @click="changeTab(tab.name)"
            :data-target="`#${tab.name}`"
            aria-expanded="true">
            <span>{{ tab.title }}</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="tab-content">
      <div class="tab-pane slide-left" :class="{ active: isActiveTab('tutorial') }" id="tutorials" aria-expanded="true">
        <tutorials-tab></tutorials-tab>
      </div>
      <div class="tab-pane slide-left" :class="{ active: isActiveTab('communication') }" id="communication" aria-expanded="false">
        <communication-tab></communication-tab>
      </div>
      <div class="tab-pane slide-left" :class="{ active: isActiveTab('guides') }" id="user-guides" aria-expanded="false">
      </div>
    </div>
  </div>
</template>

<script>
  import TutorialsTab from './TutorialsTab'
  import CommunicationTab from "./CommunicationTab";
  import UserGuidesTab from "./UserGuidesTab";
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "UserKit",
    components: {
      UserGuidesTab,
      TutorialsTab,
      CommunicationTab
    },
    computed: {
      ...mapGetters({
        activeTab: 'userKit/activeTab',
      }),
      listTab() {
        return [
          {'name': 'tutorial', 'title': this.$t("UserKit.tutorials")},
          {'name': 'communication', 'title': this.$t("UserKit.communication")}
        ]
      }
    },
    methods: {
      ...mapActions({
        setActiveTab: 'userKit/setActiveTab'
      }),
      isActiveTab(tabName) {
        return tabName == this.activeTab
      },
      changeTab(activeTab) {
        this.setActiveTab(activeTab)
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/userKit/UserKit.vue